<template>
  <div class="nav-category-dropdown-menu">
    <v-skeleton-loader
      v-if="serviceIsLoading"
      :style="{ width: '500px' }"
      type="article"
    />
    <div
      v-else
      class="nav-category-dropdown-menu__service-list"
    >
      <NavListItem
        v-for="childrenType in serviceByMainType.subTypeList"
        :key="childrenType.typeId"
        :children-type-item="childrenType"
        :type-parent-id="serviceByMainType.typeParent"
        @changeDropdownMenuStatusHandler="changeDropdownMenuStatusHandler"
      />
    </div>
  </div>
</template>

<script>
import NavListItem from './NavListItem.vue'
export default {
  name: 'NavCategoryDropDownMenu',
  components: { NavListItem },
  props: {
    serviceByMainType: {
      type: Object,
      required: true
    },
    serviceIsLoading: Boolean
  },
  methods: {
    changeDropdownMenuStatusHandler (status) {
      this.$emit('changeDropdownMenuStatusHandler', status)
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-category-dropdown-menu {
  position: absolute;
  top: $headerHeight;
  left: 0;
  background-color: $color-background-secondary;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  border-radius: 0 0 15px 15px;
  z-index: 1;
  max-width: calc(100vw - 308px - 60px - 60px - 24px);
  overflow: auto;
  &__service-list {
    padding: 24px 0 24px 34px;
    display: grid;
    grid-auto-flow: column;
    grid-template-rows: repeat(3, auto);
    min-width: 215px;
    max-height: 80vh;
    overflow: auto;
    width: max-content;
  }
}
</style>
